import { CircularProgress } from '@mui/material';
import * as React from 'react';
import type { Options } from 'react-youtube';
import Youtube from 'react-youtube';
import { makeStyles } from 'tss-react/mui';
import type { YouTubePlayer } from 'youtube-player/dist/types';
import { MAX_VIDEO_DURATION_IN_SECONDS } from '../../constants';
import useYouTubeVideoInfo from '../../hooks/useYoutubeVideoInfo';

const useStyles = makeStyles()(() => ({
  youtubeContainer: {
    position: 'relative',
    width: '100%',
    height: 0,
    paddingBottom: '56.25%',
    overflow: 'hidden',
    marginTop: 34,
    marginBottom: 34,
    '& iframe': {
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
    },
  },
  spinner: {
    margin: 35,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export interface YoutubePreviewProps {
  youtubeUrl: string;
  onDurationTooLong?: (event?: { target?: any }) => void;
  onError?: (event?: { target?: any; data: number }) => void;
  onReady?: (event?: { target?: any }) => void;
}

const YoutubePreview: React.FC<YoutubePreviewProps> = ({
  youtubeUrl,
  onDurationTooLong,
  onError,
  onReady,
}) => {
  const { classes } = useStyles();
  const { id } = useYouTubeVideoInfo(youtubeUrl);

  const options: Options = {
    playerVars: {
      controls: 1,
      rel: 0,
      fs: 0,
      enablejsapi: 1,
    },
  };

  const onHandleYoutubeReady = async (event: { target: YouTubePlayer }) => {
    const duration = event.target.getDuration() as unknown as number;
    if (duration > MAX_VIDEO_DURATION_IN_SECONDS) {
      if (onDurationTooLong) onDurationTooLong(event);
    } else if (onReady) onReady(event);
  };

  if (id) {
    return (
      <div>
        <Youtube
          videoId={id}
          opts={options}
          containerClassName={classes.youtubeContainer}
          onError={onError}
          onReady={onHandleYoutubeReady}
        />
      </div>
    );
  }
  return (
    <div className={classes.spinner}>
      <CircularProgress size={40} color="primary" />
    </div>
  );
};

export default YoutubePreview;
